import { ErrorHandler, Inject, Injectable } from '@angular/core';
import { SendEventHelper } from '@libs/helpers/send-event.helper';
import { SESSION_STORAGE } from '@libs/shared/injections/window';

@Injectable({
  providedIn: 'root',
})
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private eventHelper: SendEventHelper,
    @Inject(SESSION_STORAGE) private sessionStorage: Storage,
  ) {}

  public handleError(error: any): void {
    this.eventHelper.send(error, this.sessionStorage.getItem('phone'), 'ERROR');
  }
}
